module.exports = __webpack_public_path__ + "img/attention-white.8b3780fe.svg";